// TODO: this function must be removed from anywhere and deleted after backend model will be filled with this fields.
export function fixStockInvoiceMessage(message) {
    if (message.stockInvoice.stockName === undefined)
        message.stockInvoice.stockName = 'БЭК ДОЛЖЕН БЫЛ ВЕРНУТЬ ИМЯ СТОКА';
    if (message.stockInvoice.trackableStatus === undefined)
        message.stockInvoice.trackableStatus = 0;
}
